import React from 'react';

import styles from './IconButton.module.scss';

interface IconButtonProps {
  onClick?: (e?: any) => void;
  width?: string;
  height?: string;
  borderRadius?: string;
  backgroundColor?: string;
  style?: any;
  disabled?: boolean;
}

export default class IconButton extends React.Component<IconButtonProps> {
  public render() {
    const {
      onClick,
      disabled,
      width,
      height,
      borderRadius = '50%',
      backgroundColor = 'transparent',
      style,
    } = this.props;
    const innerComponent = this.props.children;
    return (
      <button
        className={styles.icon_button}
        style={{
          width,
          height,
          position: 'relative',
          borderRadius,
          backgroundColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style,
        }}
        disabled={disabled}
        // onChange={onChange}
        onClick={onClick}
      >
        {innerComponent}
      </button>
    );
  }
}
